<div class="w-full h-full bg-gray-100">
    <!-- <ng-container *ngIf="apiLoaded | async"> -->

        <!-- <google-map height="100%" width="100%" id="map"> -->
            <!-- <map-marker *ngFor="let markerPosition of markerPositions"
                [position]="markerPosition"></map-marker> -->
        <!-- </google-map> -->
        
        <div id="map" style="height:100%; width:100%"></div>
    <!-- </ng-container> -->
</div>
